import { TaskType } from "@/models/enums";

export const DefaultCsmDayProjectTasks = [
  {
    name: "✍️ CSM - Client Actual Time Spent",
    description: "",
    isBillable: false,
    isSystem: true,
    typeId: TaskType.cmsDays,
  },
  {
    name: "💲 Renewal & Upsell Meetings (internal & client)",
    description: "Preparation, meeting, debrief, emails follow-up, Quote, Zoho deal, Docusign",
    isBillable: false,
    isSystem: true,
    typeId: TaskType.cmsDays,
  },
  {
    name: "📑 Billing dispute",
    description: "Email, follow-up, meeting, client or internal",
    isBillable: false,
    isSystem: true,
    typeId: TaskType.cmsDays,
  },
  { name: "Client Meeting", description: "", isBillable: true, isSystem: true, typeId: TaskType.cmsDays },
  {
    name: "Client Other",
    description: "preparation, debrief, email Q&A, meeting organisation & follow-up…",
    isBillable: true,
    isSystem: true,
    typeId: TaskType.cmsDays,
  },
  {
    name: "✍️ CSTA - Client Actual Time Spent",
    description: "",
    isBillable: false,
    isSystem: true,
    typeId: TaskType.cmsDays,
  },
];

export const DefaultTicketProjectSbFactoryTasks = [
  { name: "SB Factory", description: "", isBillable: true, typeId: TaskType.sbFactoryTickets },
];

export const DefaultTicketProjectFunctionalTasks = [
  { name: "Functional Support", description: "", isBillable: true, typeId: TaskType.functionalSupportTickets },
];

export const LIMIT_DATE_FOR_NON_CHECKING_24HOURS_ON_WEEK_FIELD = "2021-03-01";
export const MAX_DAILY_HOURS = 12;
export const MAX_WEEKLY_HOURS = 60;
